import React, { useState } from "react";
import TextField from "./TextField";

export default function PasswordField({
  id = "password",
  label = "Contraseña",
  name,
  value,
  onChange,
  autoComplete = "current-password",
}) {
  const [visible, setVisible] = useState(false);

  return (
    <TextField
      id={id}
      name={name || id}
      label={label}
      type={visible ? "text" : "password"}
      value={value}
      onChange={onChange}
      autoComplete={autoComplete}
    >
      <button
        type="button"
        className="auth-reveal"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? "Ocultar contraseña" : "Mostrar contraseña"}
        aria-pressed={visible}
      >
        <i className={`bi ${visible ? "bi-eye-slash" : "bi-eye"}`} aria-hidden="true" />
      </button>
    </TextField>
  );
}
